import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class JsonDataService {
	static parse(data: any) {
		if (!data || data === "[object Object]") {
			return {};
		}

		if ((data && typeof data === "string") || data instanceof String) {
			return JSON.parse(data as string);
		}
		return data;
	}
}
